import { c as _c } from "react/compiler-runtime";
import React, { useContext, useEffect, useEffectEvent, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import { scrollToTop } from "@/app/(main)/(club)/mes-clubs/[id]/leads/utils";
import { AddressFeature } from "@/components/form/inputs/address-autocomplete-input";
import ErrorsInput from "@/components/global/inputs/errors-input";
import Spinner from "@/components/global/spinner";
import Icon from "@/components/icon";
import { sidebarContext } from "@/context/sidebar-context";
import { TextInputProps } from "@/TS/Interfaces/global_interfaces";
import { fetchAdresses } from "@/utils/user";

//==========*=*=============
// TODO en cours de refacto
//
//
//
//
//==========*=*=============

/**
 * A custom input who work with useForm by passing register={register} and a name with name={name}
 *
 * @remarks
 * [useForm docs](https://react-hook-form.com/docs/useform)
 *
 * @example
 * ```tsx
 * <TextInput
 *  register={register}
 *  name={"firstName"}
 *  type={"text"}
 *  label={"Prénom"}
 *  subLabel={"sublabel"}
 *  placeholder={"Prénom"}
 *  disabled={true}
 *  required={false}
 * ></TextInput>
 * ```
 */
function TextInput(t0) {
  const $ = _c(176);
  let autoCapitalize;
  let autoCorrect;
  let checked;
  let className;
  let containerClassName;
  let disabledClassName;
  let error;
  let errorsClassName;
  let handleStreets;
  let id;
  let inputClassname;
  let label;
  let labelClassName;
  let loading;
  let name;
  let nextLabel;
  let nextLabelClassName;
  let options;
  let placeholder;
  let radioClassName;
  let register;
  let requireClassname;
  let rest;
  let subLabel;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let value;
  if ($[0] !== t0) {
    const {
      type: t7,
      name: t8,
      error: t9,
      disabledClassName: t10,
      disabled: t11,
      required: t12,
      loading: t13,
      needed: t14,
      register: t15,
      streets: t16,
      autoCorrect: t17,
      autoCapitalize: t18,
      handleStreets: t19,
      radioName: _radioName,
      className: t20,
      labelClassName: t21,
      options: t22,
      nextLabelClassName: t23,
      nextLabel: t24,
      valueString: _valueString,
      placeholder: t25,
      label: t26,
      value: t27,
      radioClassName: t28,
      autocomplete: t29,
      checked: t30,
      subLabel: t31,
      id: t32,
      containerClassName: t33,
      requireClassname: t34,
      inputClassname: t35,
      errorsClassName: t36,
      ...t37
    } = t0;
    t1 = t7;
    name = t8;
    error = t9;
    disabledClassName = t10;
    t2 = t11;
    t3 = t12;
    loading = t13;
    t4 = t14;
    register = t15;
    t5 = t16;
    autoCorrect = t17;
    autoCapitalize = t18;
    handleStreets = t19;
    className = t20;
    labelClassName = t21;
    options = t22;
    nextLabelClassName = t23;
    nextLabel = t24;
    placeholder = t25;
    label = t26;
    value = t27;
    radioClassName = t28;
    t6 = t29;
    checked = t30;
    subLabel = t31;
    id = t32;
    containerClassName = t33;
    requireClassname = t34;
    inputClassname = t35;
    errorsClassName = t36;
    rest = t37;
    $[0] = t0;
    $[1] = autoCapitalize;
    $[2] = autoCorrect;
    $[3] = checked;
    $[4] = className;
    $[5] = containerClassName;
    $[6] = disabledClassName;
    $[7] = error;
    $[8] = errorsClassName;
    $[9] = handleStreets;
    $[10] = id;
    $[11] = inputClassname;
    $[12] = label;
    $[13] = labelClassName;
    $[14] = loading;
    $[15] = name;
    $[16] = nextLabel;
    $[17] = nextLabelClassName;
    $[18] = options;
    $[19] = placeholder;
    $[20] = radioClassName;
    $[21] = register;
    $[22] = requireClassname;
    $[23] = rest;
    $[24] = subLabel;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = value;
  } else {
    autoCapitalize = $[1];
    autoCorrect = $[2];
    checked = $[3];
    className = $[4];
    containerClassName = $[5];
    disabledClassName = $[6];
    error = $[7];
    errorsClassName = $[8];
    handleStreets = $[9];
    id = $[10];
    inputClassname = $[11];
    label = $[12];
    labelClassName = $[13];
    loading = $[14];
    name = $[15];
    nextLabel = $[16];
    nextLabelClassName = $[17];
    options = $[18];
    placeholder = $[19];
    radioClassName = $[20];
    register = $[21];
    requireClassname = $[22];
    rest = $[23];
    subLabel = $[24];
    t1 = $[25];
    t2 = $[26];
    t3 = $[27];
    t4 = $[28];
    t5 = $[29];
    t6 = $[30];
    value = $[31];
  }
  const type = t1 === undefined ? "text" : t1;
  const disabled = t2 === undefined ? false : t2;
  const required = t3 === undefined ? false : t3;
  const needed = t4 === undefined ? true : t4;
  const streets = t5 === undefined ? false : t5;
  const autocomplete = t6 === undefined ? "on" : t6;
  const [val, setVal] = useState(value);
  const [street, setStreet] = useState();
  const [isStreet, setIsStreet] = useState(false);
  const [changed, setChanged] = useState(false);
  const inputRef = useRef(null);
  const {
    panelRef
  } = useContext(sidebarContext);
  const [passwordShow, setPasswordShow] = useState(false);
  let inputType = type;
  let t7;
  if ($[32] !== passwordShow) {
    t7 = () => {
      setPasswordShow(!passwordShow);
    };
    $[32] = passwordShow;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  const togglePasswordShow = t7;
  if (passwordShow && type === "password") {
    inputType = "text";
  }
  let t8;
  if ($[34] !== handleStreets) {
    t8 = value_0 => {
      if (handleStreets) {
        fetchAdresses(value_0, setStreet);
      }
      setChanged(true);
    };
    $[34] = handleStreets;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  const handleChange = t8;
  let t9;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setChanged(false);
    };
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== error) {
    t10 = [error];
    $[37] = error;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  useEffect(t9, t10);
  let t11;
  if ($[39] !== panelRef) {
    t11 = input => {
      scrollToTop(input.offsetTop, panelRef ?? undefined, inputRef);
    };
    $[39] = panelRef;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  const scrollToInput = useEffectEvent(t11);
  let t12;
  if ($[41] !== error?.err || $[42] !== scrollToInput) {
    t12 = () => {
      if (Boolean(error?.err) && inputRef.current) {
        scrollToInput(inputRef.current);
      }
    };
    $[41] = error?.err;
    $[42] = scrollToInput;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== error) {
    t13 = [error];
    $[44] = error;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  useEffect(t12, t13);
  let t14;
  if ($[46] !== handleStreets) {
    t14 = val_0 => {
      const {
        housenumber,
        street: street_0,
        city,
        postcode
      } = val_0 ?? {};
      handleStreets(city, postcode, street_0, housenumber);
    };
    $[46] = handleStreets;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  const handleEnter = t14;
  let t15;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = _e => {
      if (setIsStreet) {
        setIsStreet(true);
      }
    };
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  const handleFocus = t15;
  let t16;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => {
      if (setIsStreet) {
        setIsStreet(false);
      }
    };
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  const handleBlur = t16;
  let t17;
  if ($[50] !== handleChange || $[51] !== value) {
    t17 = () => {
      handleChange(value);
      setChanged(false);
    };
    $[50] = handleChange;
    $[51] = value;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  const initValue = useEffectEvent(t17);
  let t18;
  if ($[53] !== initValue) {
    t18 = () => {
      initValue();
    };
    $[53] = initValue;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = [];
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  useEffect(t18, t19);
  let t20;
  let t21;
  if ($[56] !== value) {
    t20 = () => {
      setVal(value);
    };
    t21 = [value];
    $[56] = value;
    $[57] = t20;
    $[58] = t21;
  } else {
    t20 = $[57];
    t21 = $[58];
  }
  useEffect(t20, t21);
  if (type === "radio") {
    const t22 = "flex gap-2 mt-1 items-center justify-start " + className;
    let t23;
    if ($[59] !== name || $[60] !== options || $[61] !== register) {
      t23 = register(name, {
        ...options
      });
      $[59] = name;
      $[60] = options;
      $[61] = register;
      $[62] = t23;
    } else {
      t23 = $[62];
    }
    let t24;
    if ($[63] !== radioClassName) {
      t24 = twMerge("text-black bg-transparent cursor-pointer appearance-none w-4 h-4 rounded-full bg-white ring-2 ring-black flex items-center transition-all justify-center before:scale-0 before:w-4 checked:before:scale-[60%] before:rounded-full before:h-4 before:bg-black before:relative", radioClassName);
      $[63] = radioClassName;
      $[64] = t24;
    } else {
      t24 = $[64];
    }
    let t25;
    if ($[65] !== checked || $[66] !== label || $[67] !== rest || $[68] !== t23 || $[69] !== t24 || $[70] !== value) {
      t25 = <input value={value} defaultChecked={checked} type="radio" id={label} {...t23} {...rest} className={t24} />;
      $[65] = checked;
      $[66] = label;
      $[67] = rest;
      $[68] = t23;
      $[69] = t24;
      $[70] = value;
      $[71] = t25;
    } else {
      t25 = $[71];
    }
    let t26;
    if ($[72] !== label) {
      t26 = <label className="cursor-pointer" htmlFor={label}>{label}</label>;
      $[72] = label;
      $[73] = t26;
    } else {
      t26 = $[73];
    }
    let t27;
    if ($[74] !== t22 || $[75] !== t25 || $[76] !== t26) {
      t27 = <div className={t22}>{t25}{t26}</div>;
      $[74] = t22;
      $[75] = t25;
      $[76] = t26;
      $[77] = t27;
    } else {
      t27 = $[77];
    }
    return t27;
  }
  if (!disabled) {
    let t22;
    if ($[78] !== name || $[79] !== register) {
      t22 = register(name);
      $[78] = name;
      $[79] = register;
      $[80] = t22;
    } else {
      t22 = $[80];
    }
    const {
      ref
    } = t22;
    let t23;
    if ($[81] !== containerClassName) {
      t23 = twMerge("w-full relative", containerClassName);
      $[81] = containerClassName;
      $[82] = t23;
    } else {
      t23 = $[82];
    }
    const t24 = "text-md " + (labelClassName ?? "");
    let t25;
    if ($[83] !== needed || $[84] !== requireClassname) {
      t25 = needed && <span className={twMerge("text-primary ", requireClassname)}>*</span>;
      $[83] = needed;
      $[84] = requireClassname;
      $[85] = t25;
    } else {
      t25 = $[85];
    }
    let t26;
    if ($[86] !== nextLabel || $[87] !== nextLabelClassName) {
      t26 = <label className={nextLabelClassName}>{nextLabel}</label>;
      $[86] = nextLabel;
      $[87] = nextLabelClassName;
      $[88] = t26;
    } else {
      t26 = $[88];
    }
    let t27;
    if ($[89] !== id || $[90] !== label || $[91] !== t24 || $[92] !== t25 || $[93] !== t26) {
      t27 = <label className={t24} htmlFor={id}>{label}{" "}{t25}{" "}{t26}</label>;
      $[89] = id;
      $[90] = label;
      $[91] = t24;
      $[92] = t25;
      $[93] = t26;
      $[94] = t27;
    } else {
      t27 = $[94];
    }
    const t28 = `flex mt-1 border items-center h-[48px] rounded-md border-dark-grey justify-center relative ${error?.err && !changed && "border-primary  !bg-danger3 "} ${className}`;
    let t29;
    if ($[95] !== handleChange) {
      t29 = e => handleChange(e.target.value);
      $[95] = handleChange;
      $[96] = t29;
    } else {
      t29 = $[96];
    }
    let t30;
    if ($[97] !== name || $[98] !== options || $[99] !== register || $[100] !== t29) {
      t30 = register(name, {
        onChange: t29,
        onBlur: handleBlur,
        ...options
      });
      $[97] = name;
      $[98] = options;
      $[99] = register;
      $[100] = t29;
      $[101] = t30;
    } else {
      t30 = $[101];
    }
    const t31 = error?.err && !changed && "text-primary bg-danger3 border-primary";
    let t32;
    if ($[102] !== inputClassname || $[103] !== t31) {
      t32 = twMerge("w-full bg-transparent  autofill:bg-transparent!important placeholder:italic  rounded-md  pl-4 pr-1", t31, inputClassname);
      $[102] = inputClassname;
      $[103] = t31;
      $[104] = t32;
    } else {
      t32 = $[104];
    }
    let t33;
    if ($[105] !== ref) {
      t33 = e_0 => {
        ref(e_0);
        inputRef.current = e_0;
      };
      $[105] = ref;
      $[106] = t33;
    } else {
      t33 = $[106];
    }
    let t34;
    if ($[107] !== autoCapitalize || $[108] !== autoCorrect || $[109] !== autocomplete || $[110] !== id || $[111] !== inputType || $[112] !== name || $[113] !== placeholder || $[114] !== rest || $[115] !== t30 || $[116] !== t32 || $[117] !== t33 || $[118] !== value) {
      t34 = <input defaultValue={value} {...t30} onFocus={handleFocus} autoCorrect={autoCorrect} autoCapitalize={autoCapitalize} name={name} className={t32} type={inputType} placeholder={placeholder} autoComplete={autocomplete} id={id} {...rest} ref={t33} />;
      $[107] = autoCapitalize;
      $[108] = autoCorrect;
      $[109] = autocomplete;
      $[110] = id;
      $[111] = inputType;
      $[112] = name;
      $[113] = placeholder;
      $[114] = rest;
      $[115] = t30;
      $[116] = t32;
      $[117] = t33;
      $[118] = value;
      $[119] = t34;
    } else {
      t34 = $[119];
    }
    let t35;
    if ($[120] !== loading) {
      t35 = loading && <Spinner />;
      $[120] = loading;
      $[121] = t35;
    } else {
      t35 = $[121];
    }
    let t36;
    if ($[122] !== changed || $[123] !== error?.err) {
      t36 = error?.err && !changed && <Icon icon="cross" size={25} className="absolute right-2 text-primary" />;
      $[122] = changed;
      $[123] = error?.err;
      $[124] = t36;
    } else {
      t36 = $[124];
    }
    let t37;
    if ($[125] !== changed || $[126] !== error?.err) {
      t37 = error?.err === false && !changed && <Icon icon="check-simple" size={25} className="absolute right-2 text-success2" />;
      $[125] = changed;
      $[126] = error?.err;
      $[127] = t37;
    } else {
      t37 = $[127];
    }
    let t38;
    if ($[128] !== t34 || $[129] !== t35 || $[130] !== t36 || $[131] !== t37) {
      t38 = <div className="relative flex items-center bg-transparent justify-center w-full rounded-md">{t34}{t35}{t36}{t37}</div>;
      $[128] = t34;
      $[129] = t35;
      $[130] = t36;
      $[131] = t37;
      $[132] = t38;
    } else {
      t38 = $[132];
    }
    let t39;
    if ($[133] !== passwordShow || $[134] !== togglePasswordShow || $[135] !== type) {
      t39 = type === "password" && <div className={`${type === "password" ? "w-12" : "md:w-12"} flex justify-center items-center hover:cursor-pointer select-none`}><Icon size={30} icon={passwordShow ? "eye-hide" : "eye-show"} onClick={() => {
          togglePasswordShow();
        }} /></div>;
      $[133] = passwordShow;
      $[134] = togglePasswordShow;
      $[135] = type;
      $[136] = t39;
    } else {
      t39 = $[136];
    }
    let t40;
    if ($[137] !== type) {
      t40 = type === "selectDate" && <div className="md:w-12 flex justify-center items-center select-none"><Icon size={24} icon="agenda" /></div>;
      $[137] = type;
      $[138] = t40;
    } else {
      t40 = $[138];
    }
    let t41;
    if ($[139] !== required || $[140] !== subLabel) {
      t41 = subLabel && !required && <p className="bg-primary h-full cursor-text rounded-r-md flex items-center justify-center ring-1 text-lg font-bold ring-primary text-white px-4">{subLabel}</p>;
      $[139] = required;
      $[140] = subLabel;
      $[141] = t41;
    } else {
      t41 = $[141];
    }
    let t42;
    if ($[142] !== t28 || $[143] !== t38 || $[144] !== t39 || $[145] !== t40 || $[146] !== t41) {
      t42 = <div className={t28}>{t38}{t39}{t40}{t41}</div>;
      $[142] = t28;
      $[143] = t38;
      $[144] = t39;
      $[145] = t40;
      $[146] = t41;
      $[147] = t42;
    } else {
      t42 = $[147];
    }
    let t43;
    if ($[148] !== changed || $[149] !== error || $[150] !== errorsClassName) {
      t43 = <ErrorsInput changed={changed} error={error} className={errorsClassName} />;
      $[148] = changed;
      $[149] = error;
      $[150] = errorsClassName;
      $[151] = t43;
    } else {
      t43 = $[151];
    }
    let t44;
    if ($[152] !== handleEnter || $[153] !== isStreet || $[154] !== street || $[155] !== streets) {
      t44 = streets && <div style={isStreet ? {
        transform: "scale(1) translateY(100%)"
      } : {
        transform: "scale(0) translateY(100%)"
      }} className="flex-col overflow-hidden rounded-md mt-2 translate-y-full absolute z-10 -bottom-2 bg-light-grey">{Array.isArray(street) && street !== undefined && street.length !== 0 && street.map(res => <p key={res.properties.label} onMouseDown={() => handleEnter(res.properties)} className="cursor-pointer p-2 border-b-[1px] pt-4 border-grey hover:bg-grey">{res.properties.label}</p>)}</div>;
      $[152] = handleEnter;
      $[153] = isStreet;
      $[154] = street;
      $[155] = streets;
      $[156] = t44;
    } else {
      t44 = $[156];
    }
    let t45;
    if ($[157] !== t23 || $[158] !== t27 || $[159] !== t42 || $[160] !== t43 || $[161] !== t44) {
      t45 = <div className={t23}>{t27}{t42}{t43}{t44}</div>;
      $[157] = t23;
      $[158] = t27;
      $[159] = t42;
      $[160] = t43;
      $[161] = t44;
      $[162] = t45;
    } else {
      t45 = $[162];
    }
    return t45;
  } else {
    let t22;
    if ($[163] !== needed) {
      t22 = needed && <span className="text-primary">*</span>;
      $[163] = needed;
      $[164] = t22;
    } else {
      t22 = $[164];
    }
    let t23;
    if ($[165] !== label || $[166] !== t22) {
      t23 = <label htmlFor="" className="text-md">{label} {t22}</label>;
      $[165] = label;
      $[166] = t22;
      $[167] = t23;
    } else {
      t23 = $[167];
    }
    let t24;
    if ($[168] !== disabledClassName) {
      t24 = twMerge("p-2.5 text-dark-grey bg-light-grey rounded-md", disabledClassName);
      $[168] = disabledClassName;
      $[169] = t24;
    } else {
      t24 = $[169];
    }
    let t25;
    if ($[170] !== t24 || $[171] !== val) {
      t25 = <p className={t24}>{val}</p>;
      $[170] = t24;
      $[171] = val;
      $[172] = t25;
    } else {
      t25 = $[172];
    }
    let t26;
    if ($[173] !== t23 || $[174] !== t25) {
      t26 = <div className="w-full  relative">{t23}{t25}</div>;
      $[173] = t23;
      $[174] = t25;
      $[175] = t26;
    } else {
      t26 = $[175];
    }
    return t26;
  }
}
export default React.memo(TextInput);